<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2So8O2/tc-custom/9781634869317.jpg?1723408873260" alt="This image is the cover for the book Fire on Ice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fire on Ice
      </h1>
      <p class="bookDescription body article font2">
        <p>Bard Welstaad is a model Uni-Fleet officer. He’s not sure what his unit is to accomplish, marching up an icy peninsula in the frozen hell of Gelada, but without his NCO, Gordon Farrell, he knows he could not keep the unit together fighting off Snow Wasps and the savage deadly cold. Not until tragedy strikes does he admit the big sergeant means much more to him than simply being his right hand man.<br/><br/>Gordon Farrell idolizes his captain, who represents everything he reveres. The threat of imminent death finally forces him to admit the strength of his feelings as he fights to save Bard’s life. With death stalking at their heels, they can only hope to live long enough to share more than a single incredible night. Fate seems to conspire against them at every turn. Still they cling to the frail hope that somehow their love will find a way.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deirdre O’Dare
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?af993eaa